<template>
  <div class="view-forgot-password mt-5">
    <div v-if="!sent">
      <p>
        Informe o e-mail cadastrado para recuperar sua senha
      </p>
      <form>
        <form-group
          v-model="form.email"
          id="email"
          label="E-mail"
          icon="fa-regular fa-envelope"
          type="email"
          placeholder="Digite seu e-mail"
          :errors="errors.email"
          autoCheck
          @setError="setError"
          ref="formEmail"
        />

        <auth-button
          text="Recuperar senha"
          class="mt-6 pt-5"
          :loading="loading"
          :disabled="loading"
          @click="submit"
        />
      </form>

      <p class="text-center text-white fs-16 mt-6">
        <router-link class="main" :to="{ name: 'login' }">
          Voltar para login
        </router-link>
      </p>
    </div>
    <div v-else>
      <div class="d-flex justify-content-center">
        <lottie-vue-player
          :src="check"
          class="mr-6"
          autoplay
          :speed="0.8"
          :player-controls="false"
          style="width: 136px; background: transparent;"
        />
      </div>
      <p class="text-center mb-6 fs-24">
        Concluído!
      </p>
      <p class="text-center fs-16 mb-9">
        Verifique seu e-mail e siga as instruções de recuperação da senha.
      </p>
      <auth-button text="Fazer login" class="mt-3" @click="login" />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import AuthButton from "../../components/auth/AuthButton.vue";

export default {
  components: { AuthButton },
  data() {
    return {
      ...formFields(["email"]),
      sent: false,
      loading: false
    };
  },
  computed: {
    check() {
      return JSON.stringify(require("@/assets/auth/check.json"));
    }
  },
  methods: {
    setError(error, field) {
      this.errors[field] = error;
    },
    login() {
      this.$router.push({ name: "login" });
    },
    next() {
      this.choseSegment = true;
    },
    submit() {
      this.$message.hide();
      this.loading = true;
      this.$refs.formEmail.blur();

      window.grecaptcha
        .execute({ action: "submit" })
        .then(token => {
          this._submit(token);
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        });
    },
    _submit(recaptcha_token) {
      this.$store
        .dispatch("user/forgot", {
          ...this.form,
          recaptcha_token
        })
        .then(() => {
          this.sent = true;
        })
        .catch(error => {
          if (error.response.data.message) {
            this.$message.error(error.response.data.message[0]);
          } else if (!this.errors.email[0]) {
            this.errors = error.response.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-forgot-password {
  p {
    color: var(--std-neut-x-700, #d5d5d5) !important;
    margin: 0;
  }
}
</style>
